import React from 'react'
import TitleComponent from '../../../../global/Custom/TitleComponent/TitleComponent'

import { useTranslation } from 'react-i18next'
import BannerCategoryCreateScreen from './DataScreen'
import DataScreen from './DataScreen'

function DataCreate() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Tạo mới danh mục')} isExist={false} />
        <DataScreen/>
    </div>
  )
}

export default DataCreate
